// ImageCropper.js
import React, { useState, useEffect } from 'react';
import Cropper from 'react-easy-crop';
import Modal from './imageModal';
import getCroppedImg from './cropUtils';
import './ImageCropper.css';

const ImageCropper = ({ imageSrc, setCroppedImage, onCropComplete }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(true);
  
  useEffect(() => {
    if (imageSrc) {
      setIsModalOpen(true);
    }
  }, [imageSrc]);

  const onCropChange = (crop) => {
    setCrop(crop);
  };

  const onZoomChange = (zoom) => {
    setZoom(zoom);
  };

  const handleCropComplete = async (_, croppedAreaPixels) => {
    const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
    setCroppedImage(croppedImage);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
  };

  return (
    <Modal isOpen={isModalOpen} onClose={handleClose}>
      <div className="cropper-container">
        <div className="crop-container">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={16 / 9}
            onCropChange={onCropChange}
            onCropComplete={handleCropComplete}
            onZoomChange={onZoomChange}
          />
        </div>
        <div className="controls">
          <button onClick={onCropComplete} className="btn btn-primary">
            Apply
          </button>
          <button onClick={handleClose} className="btn btn-secondary">
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ImageCropper;
